import { useWriteContract } from 'wagmi';
import { useCallback } from 'react';
import { isUserRejectedError } from '../utils/errors';
const claimerAbi = require('./claimer-abi');

export function useClaim() {
  //   const [txHash, setTxHash] = useState<string | null>(null);

  // Prepare the contract write

  const {
    writeContractAsync,

    isPending,
    isSuccess,
    isError,
    error,
    data: txHash,
    reset,
  } = useWriteContract({
    mutation: {
      onSuccess: (...args) => {
        console.log('useWriteContractSuccess:', ...args);
      },
      onError: (...args) => {
        console.log('useWriteContractError:', ...args);
      },
    },
  });

  const claim = useCallback(
    async (arg: {
      chainId: number;
      claimerContractAddress: string;
      input: {
        participant: string;
        week: number;
        amount: string;
        merkleProof: string[];
      };
      onSuccess?: (txHash: string) => void;
    }) => {
      const { onSuccess } = arg;
      const { week, amount, merkleProof, participant } = arg.input;
      const { claimerContractAddress, chainId } = arg;
      //debugger;
      try {
        const res = await writeContractAsync({
          address: claimerContractAddress as `0x${string}`,
          abi: claimerAbi,
          functionName: 'claimWeek',
          chainId,
          args: [participant, week, amount, merkleProof],
        });
        console.log('Claim tx sent, hash:', res);
        onSuccess?.(res);
      } catch (e) {
        if (isUserRejectedError(e)) {
          // early return, don't re-throw. Not an actual error
          return;
        }
        throw e;
      }
    },
    [writeContractAsync],
  );

  return {
    claim,
    // writeContract,
    reset,
    isPending,
    error,
    isSuccess,
    isError,
    txHash,
  };
}

const CLAIM_WEEKS_ABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_liquidityProvider',
        type: 'address',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'week',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'balance',
            type: 'uint256',
          },
          {
            internalType: 'bytes32[]',
            name: 'merkleProof',
            type: 'bytes32[]',
          },
        ],
        internalType: 'struct MerkleRedeem.Claim[]',
        name: 'claims',
        type: 'tuple[]',
      },
    ],
    name: 'claimWeeks',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
export function useClaimWeeks() {
  //   const [txHash, setTxHash] = useState<string | null>(null);

  // Prepare the contract write

  const {
    writeContractAsync,

    isPending,
    isSuccess,
    isError,
    error,
    data: txHash,
    reset,
  } = useWriteContract({
    mutation: {
      onSuccess: (...args) => {
        console.log('useWriteContractSuccess:', ...args);
      },
      onError: (...args) => {
        console.log('useWriteContractError:', ...args);
      },
    },
  });

  const claim = useCallback(
    async (arg: {
      chainId: number;
      claimerContractAddress: string;
      input: {
        participant: string;
        week: number;
        amount: string;
        merkleProof: string[];
      }[];
      onSuccess?: (txHash: string) => void;
    }) => {
      const { onSuccess } = arg;
      const claims = arg.input.map(({ week, amount, merkleProof, participant }) => ({
        week: BigInt(week),
        balance: BigInt(amount),
        merkleProof: merkleProof as `0x${string}`[],
      }));
      const participant = arg.input[0].participant as `0x${string}`;
      const { claimerContractAddress, chainId } = arg;
      //debugger;
      try {
        const res = await writeContractAsync({
          address: claimerContractAddress as `0x${string}`,
          abi: CLAIM_WEEKS_ABI,
          functionName: 'claimWeeks',
          chainId,
          args: [participant, claims],
        });
        console.log('Claim tx sent, hash:', res);
        onSuccess?.(res);
      } catch (e) {
        if (isUserRejectedError(e)) {
          // early return, don't re-throw. Not an actual error
          return;
        }
        throw e;
      }
    },
    [writeContractAsync],
  );

  return {
    claim,
    // writeContract,
    reset,
    isPending,
    error,
    isSuccess,
    isError,
    txHash,
  };
}
